import { floorV2ApiSlice } from 'src/api/v2/floor-v2-ApiSlice';
import { RootState, store } from 'src/app/store';

export function projectHasSiren(projectId: number): boolean {
  const data = floorV2ApiSlice.endpoints.getProductsOfRoomsByFloors
    .select(Number(projectId))(store.getState() as RootState).data;
  return !!data?.floors.some(floor =>
    floor.rooms.some(room =>
      room.products.some(product => product.icon_path?.includes('siren'))
    )
  );
}